import React from "react";
import PropTypes from "prop-types";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/material/Alert';
import { makeStyles } from 'tss-react/mui';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    zIndex: 992,
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function Toast(props) {
  const { classes } = useStyles();
  const {message,severity,setOpen,open} = props;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen({
        visible: false,
        type: "",
        message: ""
    });
  };

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}


Toast.propTypes = {
  message: PropTypes.string.isRequired,
  severity: PropTypes.string.isRequired,
  setOpen: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
